export default  {
	id: '',
	name: '',
	details: '',
	description: '',
	from_the: '',
	property: '',
	subdivision: '',
	color: "",
	map_text_coords: [],
	images: []
}